import { render, staticRenderFns } from "./prospection.vue?vue&type=template&id=53f38769&scoped=true"
import script from "./prospection.vue?vue&type=script&lang=js"
export * from "./prospection.vue?vue&type=script&lang=js"
import style0 from "./prospection.vue?vue&type=style&index=0&id=53f38769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f38769",
  null
  
)

export default component.exports